export abstract class ICustomerRoutingGuardManager {
  abstract canAccessCustomerProfileView(): boolean;

  abstract canAccessCustomerCreate(): boolean;

  abstract canAccessCustomerList(): boolean;

  abstract canAccessCustomerProfileUpdate(): boolean;

  abstract canAccessCustomerEdit(): boolean;

  abstract canAccessCustomerPayers(): boolean;

  abstract canAccessCustomerChild(): boolean;
}
